export const MODULE_OPTIONS = ['Contact', 'Lead', 'Opportunity', 'Customer'].map((text) => ({
    key: text, value: text, text: text
}));
